import { FormFieldType } from '../../../../models/form-field-type';
import Primitive from '../../../../types/primitive';
import client from '../../client-unauthenticated';

export default async function submit(
  id: string,
  formData: {
    field: FormFieldType;
    values: Primitive[];
  }[]
): Promise<string> {
  const { data } = await client.post('/form/submit', {
    id,
    formData,
  });

  return data;
}
